// extracted by mini-css-extract-plugin
export default {"payments-received":"DvFYmg","paymentsReceived":"DvFYmg","title":"YK6SK1"};